export default async function ({ app, route, localePath, redirect }) {
    if (route.path === `/${app.i18n.locale}/account` || route.path === `/account`) {
        redirect(`/${app.i18n.locale}/account/orders`);
    }
}
